import { getPropsForClickTracking } from "../../utils/tracking";
import { itemCardLabel } from "../../utils/label";
<if(input.model)>
  $ const {
    card,
    sponsored,
    signalling,
    sellerName,
    sellerRating,
    previewCardAction: action,
  } = input.model;
  $ const { title, image, displayPrice } = card;
  $ const { itemCardNavigationAction, itemCardCloseAction, sellerListingCountLabel } = input.itemCardControls || {};
  $ const { previous: buttonPrev, next: buttonNext } = itemCardNavigationAction || {};
  $ const { itemIndex = 0, itemsTotal = 1 } = input;

  <div data-testid="preview-item" class="preview-item" on-keydown("onKeyDownHandler")>
    <ebay-icon-button
      data-testid="preview-item-close"
      class="preview-item-action-close"
      aria-label=itemCardCloseAction?.accessibilityText
      ...getPropsForClickTracking(itemCardCloseAction?.trackingList)
      size="small"
      on-click("onCloseHandler")
    >
      <ebay-close-16-icon/>
    </ebay-icon-button>
    <div class="preview-item-image">
      <img src=image?.URL alt=(title?.textSpans?.[0].text)>
    </div>
    <div class="preview-item-content">
      <if(sponsored)>
        <div class="preview-item-sponsored-label">
          <fe-textual-display model=sponsored/>
        </div>
      </if>
      <a
        target="_blank"
        rel="noreferrer"
        title=(title?.textSpans?.[0].text)
        href=action?.URL
        class="preview-item-title"
        ...getPropsForClickTracking(action?.trackingList)
      >
        <fe-textual-display model=title/>
      </a>
      <p class="preview-item-details">
        <fe-textual-display model=signalling/>
      </p>
      <p class="preview-item-price">
        <fe-textual-display model=displayPrice/>
      </p>
      <div class="preview-item-seller">
        <p class="preview-item-seller-name">
          <fe-textual-display model=sellerName/>
        </p>
        <p class="preview-item-seller-rating">
          <fe-textual-display model=sellerRating/>
        </p>
      </div>
    </div>
    <div class=[
      "preview-item-nav",
      {
        "preview-item-nav-hidden": itemsTotal < 2,
      },
    ]>
      <if(sellerListingCountLabel)>
        <div class="preview-item-count">
          <fe-textual-display model=itemCardLabel(sellerListingCountLabel, itemIndex, itemsTotal)/>
        </div>
      </if>
      <div class="preview-item-buttons">
        <ebay-icon-button
          size="small"
          disabled=itemIndex === 0
          aria-label=buttonPrev?.accessibilityText
          on-click("onPreviousItem")
          ...getPropsForClickTracking(buttonPrev?.trackingList)
        >
          <ebay-arrow-left-16-icon/>
        </ebay-icon-button>
        <ebay-icon-button
          size="small"
          disabled=itemIndex === itemsTotal - 1
          aria-label=buttonNext?.accessibilityText
          on-click("onNextItem")
          ...getPropsForClickTracking(buttonNext?.trackingList)
        >
          <ebay-arrow-right-16-icon/>
        </ebay-icon-button>
      </div>
    </div>
  </div>
</if>
